import React, { useEffect, useState } from "react";
import api, { fileUrl } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/Layout";
import { Landmark, Compass, Microscope, Camera, BookOpen } from "lucide-react";

const iconMap = { landmark: Landmark, compass: Compass, microscope: Microscope, camera: Camera, book: BookOpen };

export default function Initiatives() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/initiatives").then((res) => setItems(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <PageHeader testId="initiatives-header" title="हमारी पहल" subtitle="फाउंडेशन द्वारा संचालित प्रमुख कार्य, अभियान एवं पहल" />
      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-14">
        {loading ? (
          <div className="text-center py-20 text-slate-400">लोड हो रहा है...</div>
        ) : items.length > 0 ? (
          <div className="grid sm:grid-cols-2 gap-6">
            {items.map((it, idx) => {
              const Icon = iconMap[it.icon] || Landmark;
              return (
                <div key={it.id} data-testid={`initiative-${it.id}`} className="bg-white border border-amber-200/60 rounded-xl overflow-hidden shadow-sm card-hover">
                  {it.image_url && <img src={fileUrl(it.image_url)} alt={it.title} className="w-full h-48 object-cover" />}
                  <div className="p-6">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-12 h-12 rounded-lg bg-[#0a2540] text-amber-400 flex items-center justify-center shrink-0">
                        <Icon size={22} />
                      </div>
                      <h3 className="font-serif-deva text-xl text-[#0a2540]">{it.title}</h3>
                    </div>
                    <p className="prose-deva text-slate-600 text-base whitespace-pre-wrap">{it.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <EmptyState icon="lightbulb" message="फाउंडेशन की पहल शीघ्र ही यहाँ प्रदर्शित की जाएंगी।" />
        )}
      </section>
    </div>
  );
}
